/** Spanish labels for the EXACER document tipos (shared by the workbench pieces).
 * `DocumentRef.tipo` is an open string on the wire (profile-defined); an unknown
 * tipo falls back to the raw value via `labelForTipo`. */

import type { DocumentRef } from "../../api/client";

export const KIND_LABEL: Record<string, string> = {
  ine: "INE (frente)",
  ine_reverso: "INE (reverso)",
  certificado: "Certificado",
  foto: "Fotografía",
};

export function labelForTipo(tipo: DocumentRef["tipo"]): string {
  return KIND_LABEL[tipo] ?? tipo;
}

/** Review order: the certificado is what reviewers inspect most. */
export const KIND_ORDER: DocumentRef["tipo"][] = [
  "certificado",
  "ine",
  "ine_reverso",
  "foto",
];
